import { render } from "./ChevronDownIcon16.vue.js?vue&type=template&id=5c72bb4f!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ChevronDownIcon16.vue?vue&type=template&id=5c72bb4f"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__